export const shipments = {
  title: 'Shipments',
  resourceName: 'Shipments',
  totalVolume: 'Total volume (m³)',
  totalWeight: 'Total weight (kg)',
  createBtn: 'Create shipment',
  editBtn: 'Edit shipment',
  updateBtn: 'Update shipment',
  deleteBtn: 'Delete shipment',
  deleteConfirm: 'Are you sure you want to delete this shipment?',
  inWarehouse: 'In warehouse',
  split: {
    title: 'Split shipment',
    description: 'Split shipment into smaller packages.',
    successMessage: 'Split shipment successfully.',
  },
  add: {
    forOrder: 'For order {id}',
    viewOrder: 'View order',
    placeholder:
      'The add shipment form is under development. You can go back to the order detail or the shipment list.',
  },
  bulkCreate: {
    title: 'Create Shipments',
    addRow: 'Add Row',
    duplicate: 'Duplicate Row',
    view: 'Preview',
    preview: 'Preview Shipment',
    basicInfo: 'Basic Information',
    dimensions: 'Dimensions',
    warehouseInfo: 'Warehouse Information',
    additionalInfo: 'Additional Information',
    totalRows: 'Total Rows',
    summary: 'Summary',
    items: 'shipments',
    saving: 'Saving...',
    createAll: 'Create All Shipments',
  },
  detail: {
    imagesTitle: 'Shipment images',
    imagesDescription: 'You can add, remove, or update images even when the shipment already has images.',
    updateImagesSuccess: 'Shipment images updated successfully',
    updateImagesError: 'Failed to update shipment images',
    saving: 'Saving...',
    saveImages: 'Save images',
    savedSuccess: 'Saved successfully',
    pickImage: 'Choose images',
    captureImage: 'Take photo',
    uploading: 'Uploading images...',
    uploadSuccess: '{count} image(s) uploaded',
    uploadError: 'Image upload failed',
    imageAlt: 'Image {index}',
  },
  statuses: {
    ALL: 'All',
    IN_FROM_WAREHOUSE: 'In source warehouse',
    TURN_AROUND: 'Turn around',
    LOADING: 'Loading',
    IN_CONT: 'In container',
    DEPARTED: 'Departed',
    ARRIVED: 'Arrived',
    RETURNED: 'Returned',
    IN_TO_WAREHOUSE: 'In destination warehouse',
    ON_DELIVERY: 'On delivery',
    DELIVERED: 'Delivered',
    COMPLETED: 'Completed',
    LOST: 'Lost',
  },
  searchCode: {
    label: 'Search by shipment code or lading code',
    placeholder: 'Enter shipment code or lading code',
  },
  searchProduct: {
    label: 'Search by product',
    placeholder: 'Enter product name',
  },
  searchCustomer: {
    label: 'Search by customer',
    placeholder: 'Enter customer code',
  },
  filterWarehouse: {
    label: 'Filter by warehouse',
    placeholder: 'Select warehouse',
  },
  filterStartDate: {
    label: 'Shipments returned from date',
    placeholder: 'Select start date',
  },
  filterEndDate: {
    label: 'Shipments returned to date',
    placeholder: 'Select end date',
  },
  filterStatus: {
    label: 'Filter by status',
    placeholder: 'Select status',
  },
  filter: {
    placeholder: 'Search by lading code, shipment code...',
    advancedFilter: 'Advanced filter',
    clearFilter: 'Clear filter',
    search: 'Search',
    ladingCodeOrder: 'Lading code / Order',
    ladingCode: 'Lading code',
    productNameLabel: 'Product name',
    productNamePlaceholder: 'Product name',
    customerCodeLabel: 'Customer code',
    warehousePlaceholder: 'Warehouse',
    statusLabel: 'Status',
    fromDate: 'From date',
    toDate: 'To date',
    all: 'All',
  },
  list: {
    selectedCount: '{count} shipment(s) selected',
    deleting: 'Deleting...',
    deleteSelected: 'Delete selected',
    deleteConfirmOne: 'Are you sure you want to delete this shipment?',
    deleteSuccess: 'Shipment deleted',
    bulkDeleteConfirm: 'Delete {count} selected shipment(s)?',
    bulkDeleteSuccess: '{count} shipment(s) deleted',
    bulkDeleteError: 'Bulk delete failed',
    viewMore: 'View more',
    noImages: 'No images',
    ladingCode: 'Lading code',
    viewDetail: 'View details',
    edit: 'Edit',
    duplicate: 'Duplicate',
    split: 'Split',
    delete: 'Delete shipment',
    duplicateConfirm: 'Are you sure you want to duplicate this shipment?',
    duplicateSuccess: 'Shipment duplicated successfully',
    duplicateError: 'Duplicate failed',
    splitSuccess: 'Shipment split successfully',
    splitError: 'Split failed',
    splitDialogTitle: 'Split shipment',
    splitDialogDescription: 'Current shipment has {count} package(s). Enter number of packages for the new shipment (max {max}).',
    splitNewPackLabel: 'New package count',
    splitInvalidRange: 'Please enter a number between 1 and {max}',
    cancel: 'Cancel',
    splitBtn: 'Split',
    processing: 'Processing...',
    actions: 'Actions',
  },
  export: {
    button: 'Export',
    loading: 'Exporting...',
    success: 'Excel file exported successfully',
    failed: 'Failed to export Excel file',
    sheetName: 'Shipment list',
    fileName: 'Shipment_list_{date}.xlsx',
    imageButton: 'Export Image',
    columns: {
      orderCode: 'Order code',
      ladingCode: 'Lading code',
      code: 'Shipment code',
      customerCode: 'Customer',
      subCustomerCode: 'Sub customer code',
      productName: 'Product name',
      numberOfPack: 'Packages',
      totalDimensionInM3: 'Volume (m³)',
      totalWeight: 'Weight',
      fromWarehouseName: 'From warehouse',
      toWarehouseName: 'To warehouse',
      containerRefCode: 'Container',
      statusLabel: 'Status',
      orderCreatedAt: 'Order created at',
      notes: 'Notes',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
    },
  },
  fields: {
    order: 'Order',
    code: 'Shipment code',
    customer: 'Customer',
    customerCode: 'Customer code',
    images: 'Images',
    productName: 'Product name',
    productNameCn: 'Product name (Chinese)',
    totalVolume: 'Total volume (m³)',
    totalWeight: 'Total weight (kg)',
    // Backward compatibility keys
    numberOfPack: 'Number of packages',
    numberOfPackage: 'Number of packages',
    warehouse: 'Warehouse',
    fromWarehouse: 'Source warehouse',
    toWarehouse: 'Destination warehouse',
    container: 'Container',
    status: 'Status',
    pricePerKg: 'Price per kg',
    pricePerM3: 'Price per m³',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    orderCreate: 'Order created at',
    orderCreatedAt: 'Order created at',
    notes: 'Notes',
    index: 'Index',
    info: 'Info',
    priceByWeight: 'Price by weight',
    priceByVolume: 'Price by volume',
    finalPrice: 'Final price',
    subCustomerCode: 'Sub customer code',
    ladingCode: 'Lading code',
    dimensions: 'Dimensions',
    lengthOfPack: 'Length of pack (cm)',
    widthOfPack: 'Width of pack (cm)',
    heightOfPack: 'Height of pack (cm)',
    weightOfPack: 'Weight of pack (kg)',
    productDimensions: 'Product dimensions',
    lengthOfProduct: 'Length of product (cm)',
    widthOfProduct: 'Width of product (cm)',
    heightOfProduct: 'Height of product (cm)',
    weightOfProduct: 'Weight of product (kg)',
    productMaterial: 'Product material',
    information: 'Information',
    createdBy: 'Created by',
    customerInfo: 'Customer info',
    packingInfo: 'Packing info',
    productInfo: 'Product info',
    actions: 'Actions',
    // Additional fields for ShipmentShow
    mainCode: 'Main code',
    subCode: 'Sub code',
    notAssignedCustomer: 'Not assigned customer',
    packingDimensions: 'Packing dimensions',
    totalVolumeInM3: 'Total volume (m³)',
    totalWeightInKg: 'Total weight (kg)',
    totalDimension: 'Total dimension (m³)',
    totalDimensionInM3: 'Total volume (m³)',
    productNameChinese: 'Product name (Chinese)',
    additionalInfo: 'Additional information',
    additionalInformation: 'Additional information',
    warehouseInfo: 'Warehouse info',
    containerInfo: 'Container info',
    containerStatus: 'Container status',
    fromPort: 'Port of departure',
    toPort: 'Port of arrival',
    agency: 'Agency',
    shippingLine: 'Shipping line',
    noContainerInfo: 'No container info',
    product: 'Product',
    confirmationImage: 'Confirmation image',
    // Timeline translations
    timeline: {
      title: 'Timeline info',
      steps: {
        inSourceWarehouse: 'In source warehouse',
        inContainer: 'In container',
        departed: 'Departed',
        arrived: 'Arrived',
        inDestinationWarehouse: 'In destination warehouse',
        delivered: 'Delivered',
      },
      descriptions: {
        inSourceWarehouse: 'Goods are in source warehouse',
        inContainer: 'Goods are in container',
        departed: 'Container departed from port of departure',
        arrived: 'Container arrived at port of arrival',
        inDestinationWarehouse: 'Goods are in destination warehouse',
        delivered: 'Goods are delivered to customer',
      },
    },
    // Additional translations for other components
    warehouseSection: {
      goodsInWarehouse: 'Goods in warehouse',
      goodsInWarehouseWithCount: 'Goods in warehouse: {count} shipments',
      noShipmentsFound: 'No shipments found',
      customerCode: 'Customer code',
      subCodeId: 'Sub code ID',
      containerId: 'Container ID',
      containerCode: 'Container code',
      shipmentPrice: 'Shipment price',
      deliveryNote: 'Delivery note',
      selectedShipments: '{count} shipments selected',
      weight: 'Weight',
      volume: 'Volume',
      price: 'Price',
      weightPerPack: 'Weight per pack',
      noName: 'No name',
      numberOfPacks: 'Number of packs',
      deliveryNoteAdded: 'Added to delivery note {code}',
      notAdded: 'Not yet',
      total: 'Total',
    },
    actionsSection: {
      toWarehouse: 'To warehouse',
      missingPackages: 'Missing packages',
      missingPackagesTitle: 'Missing packages',
      enterActualPackages: 'Enter actual packages',
      valueMustBeBetween: 'Value must be between 0 and {max}',
      missingPackagesDueTo: 'Missing packages due to:',
      lostPackages: 'Lost packages',
      missingFromSourceWarehouse: 'Missing from source warehouse',
      packagesInSystem: 'Packages in system',
      actualPackages: 'Actual packages',
      willGoToDestination: '(Will go to destination)',
      missing: 'Missing',
      packages: 'Packages',
      missingFromSource: 'Missing from source warehouse',
      cancel: 'Cancel',
      processing: 'Processing...',
      save: 'Save',
    },
    MVD: 'Lading code',
    actual: 'Actual',
    numberOfPackages: 'Number of packages',
  },
  tabs: {
    general: 'General info',
    shipments: 'Shipments',
    price: 'Price info',
    customsDeclaration: 'Customs declaration',
  },
  totalPriceShipments: 'Total price by shipment',
  totalPrice: 'Total price',
  titles: {
    view: 'Shipment detail',
    show: 'Shipment detail',
    edit: 'Edit shipment',
    create: 'Create shipment',
    list: 'Shipment list',
  },
  buttons: {
    removeFromContainer: 'Remove from container',
    saveOrder: 'Save order',
    confirmation: 'Confirm',
    shareShipment: 'Share',
  },
  messages: {
    noData: 'No data',
    totalShipments: 'Total: {total} shipments',
    customerSelected: 'Customer selected',
    haveSubCodeButNoCustomer: 'Found sub code but no corresponding customer',
    notFoundCustomerWithCode: 'No customer found with this code',
    errorFetchingCustomer: 'Error fetching customer',
    required: {
      numberOfPack: 'Please enter number of packages',
      subCustomerCode: 'Please enter customer code',
      lengthOfPack: 'Please enter length',
      widthOfPack: 'Please enter width',
      heightOfPack: 'Please enter height',
      weightOfPack: 'Please enter weight',
      pricePerKg: 'Please enter price per kg',
      pricePerM3: 'Please enter price per m³',
      fromWarehouseId: 'Please select source warehouse',
      toWarehouseId: 'Please select destination warehouse',
      containerId: 'Please select container',
      productName: 'Please enter product name',
      images: 'Please upload images',
    },
    positive: {
      numberOfPack: 'Number of packages must be greater than or equal to 0',
      lengthOfPack: 'Length must be greater than or equal to 0',
      widthOfPack: 'Width must be greater than or equal to 0',
      heightOfPack: 'Height must be greater than or equal to 0',
      weightOfPack: 'Weight must be greater than or equal to 0',
    },
    warehouse: {
      toWarehouseId: '"Destination warehouse" must be different from "Source warehouse"',
    },
  },
  form: {
    createTitle: 'Create shipment',
    editTitle: 'Edit shipment',
    help: {
      numberOfPack: 'Number of packages in shipment',
      subCustomerCode: 'Customer code (sub code) for shipment',
      customer: 'Customer will be automatically selected based on sub code',
      ladingCode: 'Lading code for shipment',
      productName: 'Product name in shipment',
      productNameCn: 'Product name in Chinese (if any)',
      selectFromWarehouse: 'Select source warehouse',
      selectToWarehouse: 'Select destination warehouse',
    },
  },
  customsDeclaration: {
    title: 'Customs declaration info',
    description: 'This section contains customs declaration info for shipment.',
    fields: {
      customsDeclarationNumber: 'Customs declaration number',
      customsOffice: 'Customs office',
      customsAgent: 'Customs agent',
      importExportType: 'Import/export type',
      goodsDescription: 'Goods description',
      hsCode: 'HS Code',
      quantity: 'Quantity',
      unitValue: 'Unit value',
      totalValue: 'Total value',
      currency: 'Currency',
      shipments: 'Shipments',
      customsDeclarationDate: 'Customs declaration date',
    },
  },
}
